module.exports = __webpack_public_path__ + "img/solution@2x.53afcb0a.png";